module.exports = __webpack_public_path__ + "static/media/next-step-button.fea7d660.svg";